import { render } from "./halfClock.vue?vue&type=template&id=5b3628f1"
import script from "./halfClock.vue?vue&type=script&lang=js"
export * from "./halfClock.vue?vue&type=script&lang=js"

import "./halfClock.vue?vue&type=style&index=0&id=5b3628f1&lang=less"

import exportComponent from "E:\\05projects\\fullstack\\who-clicked-clock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__